import { Component, Inject, OnInit, EventEmitter,Output } from '@angular/core';
import { NotificationDialog } from './notification-timeout.modal';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
//import { RegistrationFormPrintComponent } from 'src/app/shared/components/account-request-and-pod-submission/preview-and-declare/registration-form-print/registration-form-print.component';
import { Router } from '@angular/router';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-notification-timeout',
  templateUrl: './notification-timeout.component.html',
  styleUrls: ['./notification-timeout.component.scss']
})
export class NotificationTimeoutComponent implements OnInit {

  isTerms: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: NotificationDialog, private router: Router, private dialog: MatDialog,
    public dialogRef: MatDialogRef<NotificationTimeoutComponent>,) {  
    this.isTerms = data.isTerms;
  }
  ngOnInit() {
    this.isTerms = this.data.isTerms;
    if(this.isTerms==false){
      if (sessionStorage.getItem('userId')) {
          sessionStorage.clear();
          if (environment.isCIAMRequired == 'true') {
            window.location.href = environment.revocationEndpoint;
          }
        }
        else {
          sessionStorage.clear();
        }
    }
  }

 
  close() {
    this.dialogRef.close(false);
    if (sessionStorage.getItem('userId')) {
      sessionStorage.clear();
      if (environment.isCIAMRequired == 'true') {
        window.location.href = environment.revocationEndpoint;
      }
      else {
        this.router.navigate(['']);
      }
    }
    else {
      sessionStorage.clear();
      this.router.navigate(['']);
    }
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

  
  
}
